import React, { Fragment } from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {translate} from 'react-i18next';
import { Button, Col,  Form,  Row,  Card} from 'antd';
import { MARGIN_MD, MARGIN_SM, PADDING_SM, PADDING_MD, SPAN_TWO_THIRDS, SPAN_ONE_THIRD, SPAN_FULL, MARGIN_XL} from '../../../../../../styles/constants';
import FileMappingWizardCsvColumnValueList  from '../../csv-column-value-list';
import FileMappingWizardCalcColumnValueList  from '../../calculated-field-value-list';
import FileMappingWizardComponentList from '../../component-list';
import { fileMappingWizardAddFieldFunctionWizardType, onFormulaReset,
         setFunctionEditorCursor, onCopyFieldName, fileMappingWizardAddFieldFunctionWizardRightClick,
         hideFileMappingWizardAddFieldModal, onFunctionFormDataChange, saveField, editField, onOperatorCopy } from '../actions';
import functionsData from '../../../../../../config/functions.json'
import operatorsData from '../../../../../../config/operators.json'
import { showFileMappingWizardPreviewRowList } from '../preview-row-list/actions';
import { showFileMappingWizardColumnValueList } from '../../csv-column-value-list/actions';
import { showFileMappingWizardCalculatedColumnValueList } from '../../calculated-field-value-list/actions';
import {
  DOT_STAT_COLUMN_NAME,
} from "../reducer";
import { sqlIsValid } from '../../../../../mapping-handler/dataset-builder/modals/components/utils';
import ZoomableHighlightedTextarea from '../../../../../../components/zoomable-highlighted-textarea';
import _ from "lodash";

const cardStyle = {
  type: 'inner',
  headStyle: {
    paddingLeft: PADDING_MD,
    paddingRight: PADDING_MD
  },
  bodyStyle: {
    paddingLeft: PADDING_MD,
    paddingRight: PADDING_MD,
  }
};

const cardRowStyle = {
  type: 'inner',
  bodyStyle: {
    paddingLeft: PADDING_SM,
    paddingRight: PADDING_SM,
    paddingBottom: PADDING_SM,
    paddingTop: PADDING_SM,
    marginLeft: MARGIN_SM,
    marginRight: MARGIN_SM
  }
};

const mapStateToProps = state => ({
  addFieldModalEditMode: state.scenes.dataManager.fileMapping.components.wizard.components.addField.addFieldModalEditMode,
  appLanguage: state.app.language,
  selectedColumnName: state.scenes.dataManager.fileMapping.components.wizard.shared.selectedColumnName,
  components: state.scenes.dataManager.fileMapping.components.wizard.shared.components,
  FunctionFormData: state.scenes.dataManager.fileMapping.components.wizard.components.addField.FunctionFormData,
  mergedHeader: state.scenes.dataManager.fileMapping.components.wizard.shared.mergedHeader,
  tempTableName: state.scenes.dataManager.fileMapping.components.wizard.shared.tempTableName,
});

const mapDispatchToProps = dispatch => ({
  onAddFieldModalHide: () => dispatch(hideFileMappingWizardAddFieldModal()),
  setAddFieldFunctionWizardShow: functionType => dispatch(fileMappingWizardAddFieldFunctionWizardType(functionType)),
  onFormulaReset: () => dispatch(onFormulaReset()),
  onChange: fields => dispatch(onFunctionFormDataChange(fields)),
  onPreview: () => dispatch(showFileMappingWizardPreviewRowList(false)),
  onBlur: inputTarget => dispatch(setFunctionEditorCursor(inputTarget)),
  onCopy: field => dispatch(onCopyFieldName(field)),
  onFunctionRightClick: functionExample => dispatch(fileMappingWizardAddFieldFunctionWizardRightClick(functionExample)),
  onSubmit: (tempTableName, functionData) => dispatch(saveField(tempTableName, functionData)),
  onSubmitEdit: (tempTableName, functionData) => dispatch(editField(tempTableName, functionData)),
  onOperatorCopy: operatorLabel => dispatch(onOperatorCopy(operatorLabel)),
  onCsvColumnValueListShow: columnName => dispatch(showFileMappingWizardColumnValueList(columnName)),
  onCalcColumnValueListShow: columnName => dispatch(showFileMappingWizardCalculatedColumnValueList(columnName)),
});

const mapPropsToFields = ({FunctionFormData}) => ({
  nameValue: Form.createFormField({value: FunctionFormData !== null ? FunctionFormData.nameValue : null}),
  functionValue: Form.createFormField({value: FunctionFormData !== null ? FunctionFormData.functionValue : null})
})

const onFieldsChange = (props, fields) => props.onChange(_.mapValues(fields, ({value}) => value));

const FileMappingWizardCalculatedFormula = ({
                                      t,
                                      form,
                                      appLanguage,
                                      onAddFieldModalHide,
                                      setAddFieldFunctionWizardShow,
                                      onOperatorCopy,
                                      selectedColumnName,
                                      components,
                                      onFormulaReset,
                                      FunctionFormData,
                                      onPreview,
                                      onBlur,
                                      onCopy,
                                      onFunctionRightClick,
                                      onSubmit,
                                      onSubmitEdit,
                                      tempTableName,
                                      onCsvColumnValueListShow,
                                      onCalcColumnValueListShow,
                                      mergedHeader,
                                      addFieldModalEditMode,
                                    }) => {

const getHeaders = () => {
  const mappedOutput = mergedHeader.map((obj, idx) => ({
    name: obj.name,
    key: idx,
    onDetail: () =>  obj.added ? onCalcColumnValueListShow(obj.name) : onCsvColumnValueListShow(obj.name),
    detailTitle: obj.name !== DOT_STAT_COLUMN_NAME
      ? t('scenes.dataManager.fileMapping.wizard.cards.csvHeader.csvComponentList.detail.title')
      : t('scenes.dataManager.fileMapping.wizard.cards.csvHeader.csvComponentList.dotStatColumnDetail.title'),
    calculated: obj.added,
    canAssociateValue: obj.added,
    tempTableName: obj.added ? tempTableName : null
  }));

  return mappedOutput;
}

  return (
    
    <Fragment>
        <Card {...cardStyle}>
          {t('data.fileMapping.addField.functions.label')}:
          <Row type='flex' justify='space-between' style={{marginBottom: MARGIN_MD}}>
            <Card {...cardRowStyle}>
              {functionsData.Functions.filter(f => f.Order === "0").map((f) => {
                return (
                  <Button 
                    title={appLanguage === 'en' ? f.Tooltip.en : f.Tooltip.it }
                    value={f.Name}
                    onClick={() => setAddFieldFunctionWizardShow(f)}
                    onContextMenu={(e) => {
                      e.preventDefault();
                      onFunctionRightClick(f);
                    }}
                    style={{marginRight: MARGIN_SM}}
                  >
                    {f.Name}
                  </Button>
                )
              })}
            </Card>
            <Card {...cardRowStyle}>
              {functionsData.Functions.filter(f => f.Order === "1").map((f) => {
                return (
                  <Button 
                    title={appLanguage === 'en' ? f.Tooltip.en : f.Tooltip.it }
                    value={f.Name}
                    onClick={() => setAddFieldFunctionWizardShow(f)}
                    onContextMenu={(e) => {
                      e.preventDefault();
                      onFunctionRightClick(f);
                    }}
                    style={{marginRight: MARGIN_SM}}
                  >
                    {f.Name}
                  </Button>
                )
              })}
            </Card>
          </Row>
          {t('data.fileMapping.addField.operators.label')}:
          <Row style={{marginBottom: MARGIN_MD}}>
            <Card {...cardRowStyle}>
              <Col span={SPAN_FULL}>
                <Row type='flex' justify='space-between'>
                {operatorsData.Operators.map((operatorButton) => {
                  return (
                    <Button 
                      value={operatorButton.label} 
                      style={{ marginLeft: MARGIN_SM}}
                      onClick={() => onOperatorCopy(operatorButton.label)}
                    >
                      {operatorButton.label}
                    </Button>
                  )
                })}
                </Row>
              </Col>
            </Card>
          </Row>
          <Col span={SPAN_ONE_THIRD}>
            {t('data.fileMapping.addField.fieldsList.label')}
            <Row style={{marginBottom: MARGIN_MD, height: 255}}>
              <FileMappingWizardCsvColumnValueList/>
              <FileMappingWizardCalcColumnValueList/>
              <FileMappingWizardComponentList
                components={getHeaders()}
                selected={null}
                onSelect={({name}) => onCopy(name)}
                disabled={components.map(mapping => mapping.ColumnName)}
                showValueDefinitionButton={false}
              />
            </Row>
            <Row type='flex' justify="space-between">
              <Col span={SPAN_FULL}>
                <Button
                  onClick={() => onCopy("CSVINPUTTABLE")}
                  icon="table"
                  style={{width: "100%"}}
                  >
                  {t('data.fileMapping.addField.placeholderButton.label')}
                </Button>
              </Col>
            </Row>
          </Col>
          <Col span={SPAN_TWO_THIRDS} style={{paddingLeft: PADDING_MD}}>
            <Row style={{marginBottom: MARGIN_XL, height: 255}}>
              {t('data.fileMapping.addField.formulaEditor.label')}
              {form.getFieldDecorator('functionValue')(
                <ZoomableHighlightedTextarea
                  title={form.getFieldValue('functionValue')}
                  onBlur={(e) => onBlur(e.target)}
                  modalProps={{bodyStyle: {height: "75vh"}}}
                />
              )}

            </Row>
            <Row type='flex' justify="space-between">
              <Col span={SPAN_TWO_THIRDS}>
                <Row type='flex' justify="start">
                  <Button
                    onClick ={async () => {
                      if (!sqlIsValid(FunctionFormData.functionValue, t)) return;
                      onPreview();
                    }}
                    icon="table"
                    disabled={FunctionFormData.nameValue === '' || FunctionFormData.functionValue === null || FunctionFormData.functionValue === ''}
                  >
                    {t('data.fileMapping.addField.preview.label')}
                  </Button>
                  <Button
                    onClick={onFormulaReset}
                    icon="delete"
                    style={{ marginLeft: MARGIN_MD}}>
                    {t('data.fileMapping.addField.reset.label')}
                  </Button>
                </Row>
              </Col>
              <div>
                <Button 
                  onClick={onAddFieldModalHide}
                  style={{marginRight: MARGIN_SM}}
                >
                  {t('commons.buttons.close.title')}
                </Button>
                {(addFieldModalEditMode === false) && (
                  <Button
                    onClick ={async () => {
                      if (!sqlIsValid(FunctionFormData.functionValue, t)) return;
                      onSubmit(tempTableName, FunctionFormData);
                    }}
                    type="primary"
                    disabled={FunctionFormData.nameValue === '' || FunctionFormData.functionValue === null || FunctionFormData.functionValue === ''}
                  >
                    {t('commons.buttons.confirm.title')}
                  </Button>
                )}
                {(addFieldModalEditMode === true) && (
                  <Button
                    onClick ={async () => {
                      if (!sqlIsValid(FunctionFormData.functionValue, t)) return;
                      onSubmitEdit(tempTableName, FunctionFormData);
                    }}
                    type="primary"
                    disabled={FunctionFormData.nameValue === '' || FunctionFormData.functionValue === null || FunctionFormData.functionValue === ''}
                  >
                    {t('commons.buttons.confirm.title')}
                  </Button>
                )}
              </div>
            </Row>
          </Col>
        </Card>
    </Fragment>

);
}

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps),
  Form.create({mapPropsToFields, onFieldsChange})
  )(FileMappingWizardCalculatedFormula);